<template>
  <div style="overflow: auto; max-height: 500px">
    <el-input style="width: 80%;" :placeholder="$t('portal.shu-ru-guan-jian-zi-jin-xing-guo-l')" v-model="filterText">
  </el-input>
    <el-tree ref="treeForm" size="mini" :default-checked-keys="categoryId" :placeholder="$t('portal.fu-lei')" :data="list" :default-expanded-keys="categoryId" show-checkbox node-key="id" check-strictly @check="handleNodeClick" :filter-node-method="filterNode" :key="key">
    </el-tree>
  </div>
</template>

<script>
/**
 * 父类-子类-子子类 多级选择器
 * 说明：
 * 支持el-form-item 双向数据绑定
 * <category v-model="ids"></category>
 * 参数为 [父类id, 子类id, 子类id]
 */

import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      parentCategoryList: (state) => state.erp.product.parentCategoryList,
    }),
  },
  props: {
    parentId: { //categ_parent_id
      type: [Array, String],
      default: () => [],
    },
    parentName:{//勾选数据名字
      type: String,
      default:"",
    },
    rid:{//行id
      type: String,
      default: () => "0",
    },
    categoryType: {
      type: String,
      default: () => "",
    }
  },
  data() {
    return {
      categoryId: [],
      key:1,
      list: [],
      filterText:""
    };
  },
  async created() {
    // vuex中没有地址数据则请求
    if (this.parentCategoryList.length === 0) {
      await this.$store.dispatch("erp/product/getParentCategoryList", { current_id: this.rid,categ_parent_id: this.parentId});
    }
    // 参数值
    if (this.parentId) {
      this.categoryId = [this.parentId];
    }
    // 参数值
    if (this.parentName) {
      this.filterText = this.parentName;
    }
  },
  watch: {
    rid(newVal) {
      this.$store.dispatch("erp/product/getParentCategoryList", { current_id: newVal ,categ_parent_id: this.parentId});
    },
    parentId(newVal){
      this.categoryId = newVal ? [newVal] : []
      this.key++
    },
    parentCategoryList:{
      immediate:true,
      handler: function(val) {
        if(val && val.length) {
          if(this.categoryType === 'lastLevel' ) {
            this.dataMap()
          } else if(this.categoryType === 'end_disabled'){
            this.dataEndDisabled(val)
          } 
          else {
            this.list = this.parentCategoryList
          }
        }
      }
    },
    filterText(val) {
      this.$refs.treeForm.filter(val);
    }
  },
  methods: {
    // //节点选中状态发生变化时的回调 共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点本身是否被选中、节点的子树中是否有被选中的节点
    // handleNodeClick(data, checked, node) {
    //   if (checked === true) {
    //     this.checkedId = data.id;
    //     this.$refs.treeForm.setCheckedKeys([]);
    //     this.$refs.treeForm.setCheckedKeys([data.id]);
    //     this.$emit("setValue", data);
    //   }
    // },
    filterNode(value, data) {
        if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    handleNodeClick(data, checks) {
      if (checks.checkedKeys.length) {
        this.checkedId = data.id;
        this.$refs.treeForm.setCheckedKeys([]);
        this.$refs.treeForm.setCheckedKeys([data.id]);
        this.$emit("setValue", data);
      }
    },
    dataMap() {
      const arr = JSON.parse(JSON.stringify(this.parentCategoryList))
      const fn = (arr) => {
        return arr.map(item => {
          if(item.children) {
            item.disabled = true
            item.children = fn(item.children)
          }
          return item
        })
      }
      this.list = [...fn(arr)]
    },
    dataEndDisabled(val) {
      //最后第三级不能选择
      const arr = JSON.parse(JSON.stringify(val))
      let n = 0;
      const fn = (data) => {
        n++;
        let nullCount = 0;
        let res = data.map((v, k) => {
          v.level = n;
          if (v.children?.length && n < 3) {
            v.disabled = false
            v.level = n
            v.children = fn(v.children)
          } else {
            if(n < 3) {
              v.disabled = false
            } else {
              v.disabled = true
            }
            v.end = true;
          }
          nullCount++;
          return v
        });
        if (nullCount === data.length) {
          n--;
        }
        return res
      }; 
      this.list = [...fn(arr)]
    },
  },
};
</script>

<style lang="less" scoped>
.region-picker ul > li > label {
  display: none;
}
</style>
